import EventEmitter from '@utility/eventSubscribers';
import { disconnect } from '../../../sockets/communicator';

export const createLaunchExternalAppHandler = ({ authInfo, deviceInfo, userInfo, checkData }) => () => {
  const url = authInfo?.thirdPartyAppUrl;
  if (!url) return;

  const constructUrl = url
    .replace('{brandId}', authInfo.brandId)
    .replace('{storeId}', deviceInfo?.storeId)
    .replace('{storeExternalId}', authInfo.id)
    .replace('{deviceId}', deviceInfo?.deviceId)
    .replace('{storeNumber}', authInfo.storeNumber)
    .replace('{employeeId}', deviceInfo?.employeeId || userInfo?.id)
    .replace('{checkId}', checkData?.id)
    .replace('{checkNumber}', checkData?.number)
    .replace(
      '{tableNumber}',
      checkData?.tab ? checkData?.name : checkData?.stationNumber
    );

  if (window.ReactNativeWebView) {
    EventEmitter.lauchExternalApp({ url: constructUrl });
  } else {
    window.location = constructUrl;
  }
  disconnect();
  window.sessionStorage.clear();
};
